import React from 'react';
import FlexView from 'react-flexview';
export const View = props => React.createElement(FlexView, { ...props });
export const Horizontal = (props) => (React.createElement(View, { ...props }));
export const Vertical = props => (React.createElement(View, { ...props, column: true }));
//# sourceMappingURL=layouts.js.map